import { apiLink } from "./../../../constant/api-link";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

// Import Model
import { CompanyListModel } from "../../../model/jubili/company-manage/company-index";
import { CompanyCountModel } from "../../../model/jubili/company-manage/company-count";
import { environment } from "../../../../environments/environment";
import { UpdateAccessCompanyModel } from "../../../model/jubili/company-manage/update-access-company.model";
import {CompanyPhotoModel, CompanyPhotoResponseModel} from "../../../model/jubili/company-manage/company-photo-model";
import { UpdateSwitchCompanyModel } from "../../../model/jubili/company-manage/update-switch-company.model";
import { UpdateLpmModel } from "../../../model/jubili/company-manage/update-lpm";
import { CompanySettingFormModel, UpdateCompanyFormBody } from "../../../model/jubili/company-manage/company-setting-form-data";
import { SelectorModelV2 } from "../../../model/jubili/selector-model";

@Injectable({
  providedIn: "root"
})
export class CompanyManageService {

  constructor(
    private http: HttpClient
  ) { }

  // get companylist (sort,search,filter)
  getCompanyBackOffice(companysearch: string, filterValueGrade: string, filterValueIsbadge: string,
    filterValueHide: string, filterValueIsQoPhoto: string, filterValueIsActiveLocationFeature: string, filterIsAvailable: string, filterIsNew: string, filterCountry: string, filterProvince: string, filterDistrict: string,
    limit: number, page: number, sortCol: string, sortType: number): Observable<CompanyListModel> {
    const url = apiLink.getCompanyList;
    const params = new HttpParams()
      .set("companysearch", companysearch)
      .set("filterValueGrade", filterValueGrade)
      .set("filterValueIsbadge", filterValueIsbadge)
      .set("filterValueHide", filterValueHide)
      .set("filterValueIsQoPhoto", filterValueIsQoPhoto)
      .set("filterValueIsActiveLocationFeature", filterValueIsActiveLocationFeature)
      .set("filterIsAvailable", filterIsAvailable)
      .set("filterIsNew", filterIsNew)
      .set("filterCountry", filterCountry)
      .set("filterProvince", filterProvince)
      .set("filterDistrict", filterDistrict)
      .set("limit", limit.toString())
      .set("page", page.toString())
      .set("sortCol", sortCol)
      .set("sortType", sortType.toString());

    return this.http.get<CompanyListModel>(url, { params });
  }

  // update hide company
  updateHideCompanyBackOffice(hideCompany: number, companySurr: number): Observable<boolean> {
    console.log(hideCompany);
    const url = apiLink.updateHideCompany;
    const params = new HttpParams()
      .set("hideCompany", hideCompany.toString())
      .set("companySurrkey", companySurr.toString());

    return this.http.get<boolean>(url, { params });
  }
  // update active location off limit company
  updateActiveLocationOffLimitBackOffice(isActiveLocationOffLimit: boolean, companySurr: number): Observable<boolean> {
    console.log(isActiveLocationOffLimit);
    const url = apiLink.updateActiveLocationOffLimitCompany;
    const params = new HttpParams()
      .set("isActiveLocationOffLimit", isActiveLocationOffLimit.toString())
      .set("companySurrkey", companySurr.toString());

    return this.http.get<boolean>(url, { params });
  }
  // update active geomap
  updateGeomap(isGeoMap: boolean, companySurr: number): Observable<boolean>{
    const url = apiLink.updateGeoMap;
    const params = new HttpParams()
      .set("isGeoMap", isGeoMap.toString())
      .set("companySurrkey", companySurr.toString());

    return this.http.get<boolean>(url, { params });
  }
  // update badge company
  updateBadgeCompanyBackOffice(badgecompany: number, companySurr: number): Observable<boolean> {
    const url = apiLink.updateBadgeCompany;
    const params = new HttpParams()
      .set("badgeCompany", badgecompany.toString())
      .set("companySurrkey", companySurr.toString());

    return this.http.get<boolean>(url, { params });
  }

  updateSwitchBackOffice(data : UpdateSwitchCompanyModel): Observable<boolean> {
    const url = apiLink.updateSwitchBackOffice;
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.put<boolean>(url, data, { headers });
  }

  // update is qo photo company
  updateQoPhotoCompanyBackOffice(data : UpdateSwitchCompanyModel): Observable<boolean> {
    const url = apiLink.updateQoPhotoCompany;
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.put<boolean>(url, data, { headers });
  }

  updateDataWarehouseBackOffice(data : UpdateSwitchCompanyModel): Observable<boolean> {
    const url = apiLink.updateDataWarehouse;
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.put<boolean>(url, data, { headers });
  }

  // update is active location feature company
  updateActiveLocationFeatureCompanyBackOffice(data : UpdateSwitchCompanyModel): Observable<boolean> {
    const url = apiLink.updateActiveLocationFeatureCompany;
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.put<boolean>(url, data, { headers });
  }

  updateAccessCompany(data: UpdateAccessCompanyModel): Observable<any> {
    const url = apiLink.updateAccessCompany;
    let headers = new HttpHeaders({ "Content-Type": "application/json" });

    return this.http.put(url, data, { headers });
  }
  UpdateExpireDate(data: UpdateAccessCompanyModel): Observable<any> {
    const url = apiLink.updateExpireDate;

    const headers = new HttpHeaders({ "Content-Type": "application/json" });

    return this.http.put(url, data, { headers });
  }

  getCompanyPhoto(searchText: string, currentPage: number, maxPage: number): Observable<CompanyPhotoResponseModel> {
    const url = apiLink.getCompanyPhoto;
    const params = new HttpParams()
      .set("searchText", searchText)
      .set("currentPage",currentPage.toString() )
      .set("maxPage", maxPage.toString());
    return this.http.get<CompanyPhotoResponseModel>(url, { params });
  }
  getCompanySettingFormBackOffice(companySurrKey: number): Observable<Array<CompanySettingFormModel>> {
    const url = apiLink.getCompanySettingFormBackOffice;
    const params = new HttpParams().set("companySurrKey", companySurrKey.toString());
    return this.http.get<Array<CompanySettingFormModel>>(url, {params: params});
  }
  getFormSelector(formType: number, language: number): Observable<Array<SelectorModelV2>> {
    const url = apiLink.getFormSelector;
    const params = new HttpParams()
    .set("formType", formType.toString() || null)
    .set("language", language.toString() || null);
    return this.http.get<Array<SelectorModelV2>>(url, {params: params});

  }
  updateCompanyForm(body: UpdateCompanyFormBody): Observable<boolean> {
    const url = apiLink.updateCompanyForm;
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.post<boolean>(url, body, {headers: headers});
  }
  countCompanyStatus(companysearch: string, filterValueGrade: string, filterValueIsbadge: string,
    filterValueHide: string, filterValueIsQoPhoto: string, filterValueIsActiveLocationFeature: string, filterIsAvailable: string, filterIsNew: string, filterCountry: string, filterProvince: string, filterDistrict: string): Observable<CompanyCountModel> {
    const params = new HttpParams()
    .set("companysearch", companysearch)
    .set("filterValueGrade", filterValueGrade)
    .set("filterValueIsbadge", filterValueIsbadge)
    .set("filterValueHide", filterValueHide)
    .set("filterValueIsQoPhoto", filterValueIsQoPhoto)
    .set("filterValueIsActiveLocationFeature", filterValueIsActiveLocationFeature)
    .set("filterIsAvailable", filterIsAvailable)
    .set("filterIsNew", filterIsNew)
    .set("filterCountry", filterCountry)
    .set("filterProvince", filterProvince)
    .set("filterDistrict", filterDistrict);
    const url = apiLink.countCompanyStatus;
    return this.http.get<CompanyCountModel>(url, {params});
  }

  updateLpmName(val: UpdateLpmModel): Observable<boolean>{
    const url = apiLink.updateLpmName;
    const headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.put<boolean>(url, val, { headers });
  }

  exportCompanyLicense(
    companysearch: string,
    filterValueGrade: string,
    filterValueIsbadge: string,
    filterValueHide: string,
    filterValueIsQoPhoto: string,
    filterValueIsActiveLocationFeature: string,
    filterIsAvailable: string,
    filterIsNew: string,
    filterCountry: string,
    filterProvince: string,
    filterDistrict: string,
    limit: number,
    page: number,
    sortCol: string,
    sortType: number
    ): Observable<Blob> {
    const url = apiLink.exportCompanyLicense;
    
    const params = new HttpParams()
    .set("companysearch", companysearch)
    .set("filterValueGrade", filterValueGrade)
    .set("filterValueIsbadge", filterValueIsbadge)
    .set("filterValueHide", filterValueHide)
    .set("filterValueIsQoPhoto", filterValueIsQoPhoto)
    .set("filterValueIsActiveLocationFeature", filterValueIsActiveLocationFeature)
    .set("filterIsAvailable", filterIsAvailable)
    .set("filterIsNew", filterIsNew)
    .set("filterCountry", filterCountry)
    .set("filterProvince", filterProvince)
    .set("filterDistrict", filterDistrict)
    .set("limit", limit.toString())
    .set("page", page.toString())
    .set("sortCol", sortCol)
    .set("sortType", sortType.toString());

    return this.http.get<Blob>(url, { params: params, responseType: 'arraybuffer' as 'json' });
  }
}
